import React from 'react';
import Carousel from '../../components/Carousel';

export default function ProjectsPage() {
  return (
    <div>
      <h2 className="heading fade-in-top">Projects</h2>
      <Carousel />
    </div>
  );
}
